import { Einblenden, Etikett } from './Bausteine'
import { zielgruppen, zielgruppenAbschnitt } from '@/data/inhalte'

/** „Für wen ist der Live-Talk?“ - zwei Gruppen, reine Darstellung (keine Auswahl, Wunsch 06.10.2026). */
export default function Zielgruppen() {
  return (
    <section id="zielgruppen" className="bg-white py-20 sm:py-28">
      <div className="huelle">
        <Etikett>{zielgruppenAbschnitt.etikett}</Etikett>
        <Einblenden>
          <h2 className="mt-10 max-w-[22ch] text-[clamp(32px,4.2vw,54px)] text-konf-nacht">{zielgruppenAbschnitt.titel}</h2>
        </Einblenden>
        <div className="mt-14 grid gap-12 md:grid-cols-2 md:gap-10 lg:gap-16">
          {zielgruppen.map((g, i) => (
            <Einblenden key={g.gruppe} verzoegerung={i * 100}>
              <span aria-hidden="true" className="block h-[3px] w-full bg-gradient-to-r from-konf-teal via-konf-blau to-konf-violett" />
              <h3 className="mt-5 font-display text-[12.5px] font-medium uppercase tracking-[0.3em] text-konf-teal">{g.gruppe}</h3>
              <ul className="mt-4 divide-y divide-linie">
                {g.eintraege.map(e => (
                  <li key={e} className="flex items-center gap-4 py-4 font-display text-[20px] font-bold leading-snug tracking-[-0.01em] text-konf-nacht sm:text-[22px]">
                    <svg aria-hidden="true" viewBox="0 0 20 23" className="h-4 w-4 shrink-0">
                      <path d="M10 1l8.5 4.9v9.8L10 21.5 1.5 15.7V5.9Z" fill="none" stroke="#017C76" strokeWidth="2" />
                    </svg>
                    {e}
                  </li>
                ))}
              </ul>
            </Einblenden>
          ))}
        </div>
      </div>
    </section>
  )
}
